import React, { useEffect, useState } from "react";
import DashboardShell from "../../components/layout/DashboardShell";
import { Card, Pill } from "../../components/common/Primitives";
import api from "../../lib/api";

export default function InvestorQueries() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/investor/queries").then((r) => setRows(r.data || [])); }, []);

  return (
    <DashboardShell title="My Queries" subtitle="INVESTOR · Q&A LOG">
      {rows.length === 0 ? (
        <div className="border border-dashed border-white/15 p-10 text-center text-ink-muted">No queries yet.</div>
      ) : (
        <div className="space-y-4">
          {rows.map((q) => (
            <Card key={q.query_id} testId={`iq-${q.query_id}`}>
              <div className="flex items-center justify-between mb-3">
                <div className="overline">Query · {q.query_id.slice(0, 12)}</div>
                <Pill tone={q.status === "Response Shared" ? "success" : "warn"}>{q.status}</Pill>
              </div>
              <ul className="space-y-2 mb-3">
                {(q.questions || []).map((qq) => <li key={qq.question_id} className="text-ink-soft text-sm">• {qq.question}</li>)}
              </ul>
              {q.status === "Response Shared" && q.answer && (
                <div className="border border-gold/40 bg-gold/[0.03] p-3">
                  <div className="overline mb-1">Startup Response</div>
                  <div className="text-sm text-ink-soft leading-relaxed">{q.answer}</div>
                </div>
              )}
              {q.status !== "Response Shared" && (
                <div className="text-ink-muted text-xs italic">Response pending admin review before it can be shared.</div>
              )}
            </Card>
          ))}
        </div>
      )}
    </DashboardShell>
  );
}
